export const MOBILE_PAGE_CONFIG = {
  name: 'MetricConfig',
  className: 'dbb-explore-metric-detail',
  children: [
    {
      name: 'CommonHeader',
      config: {
        title: {
          name: 'MetricDetailTitle',
          config: {
            subTitle: 'For any questions, contact {{name}}.',
            subTitleCn: '如有问题，请联系 {{name}}。',
          },
        },
        operationList: {
          name: 'MetricDetailOperation',
          config: {
            title: 'Is this benchmark useful for you?',
            titleCn: '该Benchmark对您是否有用？',
            api: '/api/v2/dashboard/benchmark/metric/expansion/info',
            clickApi: '/api/v2/dashboard/benchmark/metric/expansion',
            dataKey: 'like',
          },
        },
      },
      children: [
        {
          name: 'CommonContantWrap',
          config: {
            logConfig: {
              typeId: 'benchmark_mobile',
              uid: "",
              uidType: "",
              pageId: '800301',
              pageName: 'benchmarkExploreMobileMetricDetail',
              extInfo: {
                metricKey: '{{metricKey}}',
                metricNameEn: '{{metricNameEn}}',
                metricNameCn: '{{metricNameCn}}',
              },
              pagePath: '/benchmark/mobile/explore/metricDetail',
            },
          },
          children: [
            {
              name: 'MetricDetailFilter',
              filterPath: '/benchmark/mobile/explore/metricDetail',
              children: [
                {
                  "name": "MetricDetailTips",
                  "className": "",
                  "style": { "marginTop": "20px" },
                  "props": {
                    "config":
                    {
                      "titleEn": "DataBrain Tips",
                      "titleCn": "DataBrain Tips"
                    },
                  }
                },
                {
                  name: 'MetricDetailGroupService',
                  props: {
                    api: '/api/v2/dashboard/benchmark/metric_info'
                  },
                  children: [
                    {
                      name: 'MetricDetailCardService',
                      props: {
                        config: {
                          api: '/api/v2/dashboard/benchmark/metric',
                        },
                      },
                      children: [
                        {
                          name: 'CommonRow',
                          className: '',
                          type: 'layout',
                          style: {
                            "margin": "20px 0px 18px"
                          },
                          props: {},
                          children: [
                            {
                              "name": "MetricDetailCardContext",
                              "props": {
                                "config": {
                                  "subTitleEn": 'Game Contributors : {{game_contributors|dataFormat;thousandsInit}}',
                                  "subTitleCn": '游戏总量 ：{{game_contributors|dataFormat;thousandsInit}}',
                                  "subTitleKey": 'game_contributors',
                                  "sourceTitleEn": "Data Source:",
                                  "sourceTitleCn": "数据源：",
                                  "rightTextEn": 'Data update : {{last_update_date|dateTimeFormat;YYYY-MM}}',
                                  "rightTextCn": '数据更新日期 ：{{last_update_date|dateTimeFormat;YYYY-MM}}',
                                  "rightTextKey": 'last_update_date',
                                  "contentsTitles":
                                    [
                                      {
                                        "titleEn": 'Top 1%',
                                        "titleCn": '前1%',
                                        "className": 'dbb-top-1',
                                        "style": {},
                                        "rainbowKey": 'Benchmark Top 1',
                                        "bubble": '',
                                        'value': 'top1%',
                                        'dataKey': 'top1per'
                                      },
                                      {
                                        "titleEn": 'Top 10%',
                                        "titleCn": '前10%',
                                        "className": 'dbb-top-10',
                                        "style": {},
                                        "rainbowKey": 'Benchmark Top 10',
                                        "bubble": '',
                                        'value': 'top10%',
                                        'dataKey': 'top10per'
                                      },
                                      {
                                        "titleEn": 'Median',
                                        "titleCn": '中位数',
                                        "className": 'dbb-median',
                                        "style": {},
                                        "rainbowKey": 'Benchmark Median',
                                        "bubble": '',
                                        'value': 'median',
                                        'dataKey': 'median'
                                      },
                                      {
                                        "titleEn": '',
                                        "titleCn": '',
                                        "className": 'dbb-otdr',
                                        "style": {},
                                        "rainbowKey": 'Benchmark GTDR',
                                        "titleTipPlacement": 'top-end',
                                        'value': 'otdr',
                                        'dataKey': 'otdr',
                                        'isHaveValueExplain': true
                                      },
                                    ],
                                }
                              }
                            }
                          ],
                        },
                      ],
                    }
                  ]
                },
                {
                  name: 'MetricDetailTabService',
                  className: '',
                  type: 'layout',
                  style: {
                    marginTop: '18px',
                  },
                  props: {
                    logConfig: {
                      buttonId: '800301001',
                      pageId: '800301',
                      typeId: 'benchmark_mobile',
                    },
                    tabsOptions: {
                      options: [
                        {
                          value: 'genre',
                          text: { textEn: 'Genre', textCn: '品类' },
                          bubble: {
                            textEn: 'Display data by different genres.',
                            textCn: '按不同游戏类型展示数据',
                          },
                        },
                        {
                          value: 'country',
                          text: { textEn: 'Country', textCn: '国家' },
                          bubble: {
                            textEn: 'Display data by different country.',
                            textCn: '按不同国家展示数据',
                          },
                        },
                        {
                          value: 'platform',
                          text: { textEn: 'Platform', textCn: '平台' },
                          bubble: {
                            textEn: 'Display data by different platforms.',
                            textCn: '按不同平台展示数据',
                          },
                        },
                      ],
                    },
                    radioOptions: {
                      options: [
                        {
                          value: 'top1per',
                          textEn: 'Top 1%',
                          textCn: '前 1%',
                          key: 'top1%'
                        },
                        {
                          value: 'top10per',
                          textEn: 'Top 10%',
                          textCn: '前 10%',
                          key: 'top10%',
                        },
                        {
                          value: 'median',
                          textEn: 'Median',
                          textCn: '中位数',
                          key: 'median',
                        },
                      ],
                      defaultValue: 'median',
                    },
                  },
                  children: [
                    {
                      name: 'TabsAndRadio',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {},
                      children: [
                        {
                          name: 'MetricDetailChartService',
                          "style": { "marginTop": "18px" },
                          props: {
                            config: {
                              api: '/api/v2/dashboard/benchmark/dimension/trend',
                            },
                          },
                          children: [
                            {
                              name: 'MetricDetailChart',
                              className: 'dbb-metric-chart',
                              props: {},
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'MetricDetailTableService',
                  className: '',
                  type: 'layout',
                  style: {},
                  "props": {
                    percentileTip: {
                      tooltipEn: "Calculate the percentile ranking of the game metric value under the current filtering conditions, which represents how many games this game currently exceeds.",
                      tooltipCn: "计算游戏指标值在当前筛选条件下的相对排名，该数值代表本游戏目前超过了多少的游戏",
                    },
                    searchConfig: {
                      textEn: 'Enter your game data to see where you rank.',
                      textCn: '输入您游戏的数值以查询百分位排名',
                      resultEn: 'Your game is outranking  {{value}}% of games',
                      resultCn: '您的游戏超过了 {{value}}% 的游戏',
                      errorTextEn: 'Input error, Please enter number',
                      errorTextCn: '输入错误，请输入数字',
                      percentErrorTextEn: 'Input error, the input value must be less than or equal to 100',
                      percentErrorTextCn: '输入错误，输入值需小于等于100',
                    }
                  },
                  children: [
                    {
                      name: 'BenchMarkTable',
                      className: '',
                      type: 'layout',
                      style: {
                        marginTop: '20px',
                      },
                      props: {
                        dimColumnWidth: 320,
                        activeTab: {
                          value: 'game',
                          text: { textCn: '游戏', textEn: 'Game' },
                        },
                        activeRadio: true,
                        openLastColumnAutoWidth: false,
                        radioValueKey: 'value_type',
                        config: {
                          titleEn: 'Game Detail',
                          titleCn: '游戏详情',
                          secTitleCn:
                            'Benchmark数据由腾讯真实项目脱敏数据和外部多方数据源得出，如下游戏列表仅展示外部数据源游戏项目数据',
                          secTitleEn:
                            'Benchmark data comes from anonymized Tencent projects and external sources. The following game list shows only external data.',
                          api: {
                            tableApi:
                              '/api/v2/dashboard/benchmark/overall_performance',
                            tableDownloadApi:
                              '/api/v2/dashboard/benchmark/overall_performance/download',
                          },
                          downConfig: {
                            customDownNameEn: 'Benchmark_Game Detail',
                            customDownNameCn: '游戏详情',
                            defaultFileType: 'excel',
                          },
                          customColumnsBeforeDim: [
                            {
                              columnKey: 'release_time',
                              valueKeyEn: 'release_time',
                              valueKeyCn: 'release_time',
                              nameEn: 'Release Date',
                              nameCn: '发布日期',
                              enWidth: 180,
                              cnWidth: 180,
                              showTabs: ['game'],
                              formatRule: 'YYYY-MM-DD'
                            },
                            {
                              columnKey: 'genre',
                              valueKeyEn: 'game_genre',
                              valueKeyCn: 'game_genre_cn',
                              nameEn: 'Main Genre',
                              nameCn: '主品类',
                              enWidth: 200,
                              cnWidth: 200,
                              sorter: false,
                              filter: true,
                              showTabs: ['game'],
                              tooltipEn:
                                'The IEGG genre tags for mobile games is the result of a comprehensive review by Game Research Center experts of the data available in the database.The IEGG genre tags for PC games are provided by Game Research Center reviewers based on Steam Tags，while the genre tags for Console games are provided by Game Research Center reviewers based on the Steam Tags for the PC game of the same name and reference to Pioc Pixels.',
                              tooltipCn:
                                '手游的IEGG品类标签是Game Research Center专家综合数据库可用的数据进行综合评测提供的，PC游戏的IEGG品类标签是Game Research Center的评测专家根据Steam Tags提供的，而Console游戏的IEGG品类标签是Game Research Center的评测专家根据同名PC游戏的Steam Tags以及参考Pioc Pixels提供的。',
                            },
                          ],
                          otherParams: {
                            "is_show_percentile": true
                          }
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
